export default {"src":"__ASTRO_ASSET_IMAGE__BC9w7V53__","width":720,"height":401,"format":"jpg"}